import { PremiumUI } from "./PremiumUI";

function PremiumFull() {
  return <PremiumUI variant="page"/>;
}

export default PremiumFull;
